<template>
    <Stub />
</template>

<script>
import Stub from '@/components/common/Stub';

export default {
    name: 'CharityDonations',
    components: {
        Stub,
    },
};
</script>
